/**
 * Hygge Crafting Journal - CoraCreaCrafts
 * (c) 2025 CoraCreaCrafts. All rights reserved.
 * This code is protected and obfuscated.
 */
function _0x4c4f(_0x2e906b, _0x546a5e) {
  _0x2e906b = _0x2e906b - 0x19b;
  var _0x130f06 = _0x130f();
  var _0x4c4fd8 = _0x130f06[_0x2e906b];
  return _0x4c4fd8;
}
function _0x130f() {
  var _0x263e60 = [
    'random',
    'The\x20Science\x20Behind\x20Hygge\x20Crafting',
    'offset',
    'min',
    '517032hvIHPu',
    '\x22\x20alt=\x22Hygge\x20Winter\x20Journaling\x22\x20class=\x22featured-journal-image\x22\x20/><div\x20class=\x22featured-caption\x22>The\x20Danish\x20Art\x20of\x20Cozy\x20Winter\x20Journaling</div></div>',
    'globalCompositeOperation',
    '2SabjmS',
    'sqrt',
    'article',
    'https://cdn.shopify.com/s/files/1/0709/1594/8764/files/gen-z-vintage-crafting-featured.jpg',
    'remove',
    'https://cdn.shopify.com/s/files/1/0709/1594/8764/files/202408_CelticKnots2.jpg?v=1726029765',
    'dedication',
    'getImageData',
    'turn',
    '637260Lhbwua',
    '.music-icon',
    'all',
    'ready',
    'rgba(130,\x20100,\x2070,\x200)',
    'classList',
    'pageX',
    'src',
    'Ephemera\x20Collection',
    'Winter\x20Hygge\x20Supply\x20Essentials',
    'removeClass',
    'multiply',
    'title',
    'open',
    '0.35',
    'once',
    '3955896kgOSdY',
    'querySelector',
    '<div\x20class=\x22article-body\x22><p>Pinterest\x27s\x20annual\x20\x22Pinterest\x20Predicts\x22\x20report\x20(with\x20an\x2080%\x20accuracy\x20rate)\x20just\x20revealed\x206\x20major\x20trends\x20perfect\x20for\x20journaling:</p></div><div\x20class=\x22trend-entry\x22><span\x20class=\x22trend-number\x22>1.</span><span\x20class=\x22trend-title\x22>Lace\x20Revival</span><div\x20class=\x22article-body\x22><p>Lace\x20elements,\x20crochet\x20details,\x20and\x20doily\x20accents\x20are\x20making\x20a\x20comeback.\x20Searches\x20for\x20\x22lace\x20doily\x22\x20are\x20up\x20105%.\x20Incorporate\x20vintage\x20lace,\x20<a\x20href=\x22https://coracreacrafts.com/products/coquette-washi-tape-set?ref=blog-hygge\x22\x20class=\x22vintage-link\x22>lace-patterned\x20washi\x20tape</a>,\x20and\x20doily\x20die-cuts\x20into\x20your\x20spreads\x20for\x20romantic,\x20feminine\x20touches.</p></div></div>',
    'width',
    'featured',
    'floor',
    'single',
    '</div>',
    'offsetX',
    'sin',
    'match',
    'stopPropagation',
    'previous',
    'Previous',
    'closest',
    'css',
    'Mystic\x20Gel\x20Pens',
    'querySelectorAll',
    'opacity',
    '.book-container',
    'left',
    'Step-by-Step',
    'Frequently\x20Asked\x20Questions',
    'Elven\x20Pastes',
    '#flipbook',
    'hyggeFeaturedImage',
    'disabled',
    'translate',
    'rgb(',
    'style',
    'https://cdn.shopify.com/s/files/1/0709/1594/8764/files/202506_GelPens25.jpg?v=1755091171',
    'undefined',
    'Explore\x20All\x20Products',
    'loop',
    'Garden\x20Pond\x20Washi\x20Tape',
    'addColorStop',
    '<div\x20class=\x22article-body\x22><p>Yesterday\x20evening,\x20wrapped\x20in\x20my\x20favorite\x20blanket\x20while\x20the\x20temperature\x20dropped\x20outside,\x20I\x20discovered\x20hygge\x20crafting\x20\x26mdash;\x20the\x20Danish\x20art\x20of\x20creating\x20cozy\x20journal\x20spreads\x20by\x20candlelight.</p></div><div\x20class=\x22intro-ornament\x22>\x26#10087;</div><div\x20class=\x22article-body\x22><p><em>Hygge\x20(pronounced\x20\x22hoo-gah\x22)\x20celebrates\x20coziness\x20and\x20contentment\x20through\x20simple\x20pleasures.</em></p></div>',
    'backcover',
    'keydown',
    'Coquette\x20Washi\x20Tape\x20Set',
    'music-on',
    'https://cdn.shopify.com/s/files/1/0709/1594/8764/files/hygge-winter-journaling-cozy-setup.jpg',
    'textContent',
    'preventDefault',
    'Aging\x20&\x20Dusty\x20Inkpads',
    'What\x20Makes\x20Crafting\x20\x22Hygge\x22',
    'createRadialGradient',
    '30-Day\x20Hygge\x20Crafting\x20Challenge',
    'hyggeBackgroundMusic',
    '#prevBtn',
    'PageUp',
    'scale',
    '9iwXceP',
    'save',
    '187FOGRMo',
    'then',
    'https://cdn.shopify.com/s/files/1/0709/1594/8764/files/202212_Inkpads-e1670523356134.jpg?v=1726023378',
    'pages',
    'fill',
    'catch',
    'ArrowRight',
    'coverCanvas',
    'currentTime',
    'Trends\x20Continued',
    'max',
    'ephemera',
    'rgba(0,0,0,0.5)',
    'playing',
    'next',
    'click',
    'onerror',
    'Supplies\x20Needed',
    '.vintage-link',
    'type',
    'content',
    '#rolledSpine',
    'text',
    '2043692opuPQW',
    'page',
    'height',
    'rendered',
    '.page',
    'rgba(255,255,255,0.1)',
    'rgba(130,\x20100,\x2070,\x20',
    'prop',
    'addClass',
    'image',
    'open\x20closing',
    '\x20L\x20',
    'Making\x20It\x20a\x20Sustainable\x20Practice',
    'dataset',
    'hiding',
    'href',
    '#leatherCover',
    'add',
    '<div\x20class=\x22back-cover-content\x22><div\x20class=\x22back-heading\x22>Ready\x20to\x20Begin?</div><div\x20class=\x22cta-stamps\x22><a\x20href=\x22https://coracreacrafts.com/collections/all?ref=blog-hygge\x22\x20class=\x22cta-stamp\x22><span\x20class=\x22stamp-text\x22>Explore\x20Collections</span></a><a\x20href=\x22https://coracreacrafts.com/products/vintage-craft-supplies-box-monthly-subscription?ref=blog-hygge\x22\x20class=\x22cta-stamp\x22><span\x20class=\x22stamp-text\x22>Monthly\x20Subscription</span></a></div><div\x20class=\x22community-section\x22><div\x20class=\x22community-heading\x22>Join\x20Our\x20Community</div><div\x20class=\x22community-buttons\x22><a\x20href=\x22https://discord.gg/coracreacrafts\x22\x20class=\x22community-btn\x20discord-btn\x22\x20target=\x22_blank\x22><span>Discord</span></a><a\x20href=\x22https://www.instagram.com/coracreacrafts/\x22\x20class=\x22community-btn\x20instagram-btn\x22\x20target=\x22_blank\x22><span>Instagram</span></a></div></div><div\x20class=\x22wax-seal\x22></div><div\x20class=\x22back-quote\x22>Welcome\x20to\x20the\x20coziest\x20creative\x20practice\x20you\x27ll\x20ever\x20develop.<br>Welcome\x20to\x20hygge\x20crafting.<br>Welcome\x20home.</div></div>',
    '109779aofsKC',
    'haunted-transparent-tapes',
    'rgba(0,0,0,0)',
    'pause',
    'closing',
    'fillRect',
    'length',
    'arc',
    'key',
    'HyggeJournal',
    'createLinearGradient',
    '215SjItWw',
    'top',
    'innerWidth',
    'hyggeFireplaceSound',
    'volume',
    'getElementById',
    'rgba(0,0,0,0.4)',
    'getContext',
    'data',
    '<div\x20class=\x22trend-entry\x22><span\x20class=\x22trend-number\x22>6.</span><span\x20class=\x22trend-title\x22>Afrohemian\x20Decor</span><div\x20class=\x22article-body\x22><p>Vibrant\x20textile\x20patterns,\x20warm\x20earth\x20tones,\x20and\x20handwoven\x20textures\x20celebrate\x20global\x20craft\x20traditions.\x20Incorporate\x20mudcloth\x20patterns,\x20natural\x20materials,\x20and\x20cultural\x20richness.</p></div></div><div\x20class=\x22divider\x22>&#8729;\x20&#8729;\x20&#8729;</div><h3\x20class=\x22subsection-heading\x22>Creating\x20Your\x20First\x20Hygge\x20Journal\x20Spread</h3><div\x20class=\x22article-body\x22><p><strong>Winter\x20Solstice\x20Ritual\x20Spread</strong>\x20&#8211;\x20A\x20perfect\x20introduction\x20to\x20hygge\x20crafting.</p></div>',
    'body',
    'hyggeBookOpenSound',
    'music-off',
    'rgba(90,\x2065,\x2040,\x20',
    '2934540AkmEby',
    'hidden',
    'visible',
    'restore',
    'addEventListener',
    'play',
    'https://cdn.shopify.com/s/files/1/0709/1594/8764/files/202509_HalloweenPET.jpg?v=1761905323',
    '<div\x20class=\x22faq-entry\x22><div\x20class=\x22faq-question\x22>How\x20do\x20you\x20pronounce\x20\x22hygge\x22?</div><div\x20class=\x22faq-answer\x22>It\x27s\x20pronounced\x20\x22hoo-gah\x22\x20(with\x20a\x20soft\x20\x27h\x27).\x20The\x20\x27yg\x27\x20makes\x20a\x20sound\x20similar\x20to\x20\x22oo\x22\x20in\x20\x22good.\x22</div></div><div\x20class=\x22faq-entry\x22><div\x20class=\x22faq-question\x22>Is\x20hygge\x20crafting\x20expensive?</div><div\x20class=\x22faq-answer\x22>No!\x20Start\x20with\x20free\x20supplies\x20(papers\x20from\x20your\x20mail,\x20nature\x20findings,\x20old\x20books\x20from\x20thrift\x20stores)\x20or\x20a\x20basic\x20$40\x20kit.\x20Thoughtful\x20curation\x20matters\x20more\x20than\x20massive\x20hauls.</div></div><div\x20class=\x22faq-entry\x22><div\x20class=\x22faq-question\x22>I\x27m\x20a\x20complete\x20beginner\x20&#8211;\x20can\x20I\x20do\x20this?</div><div\x20class=\x22faq-answer\x22>Absolutely!\x20Hygge\x20crafting\x20celebrates\x20imperfection.\x20If\x20you\x20can\x20tear\x20paper\x20and\x20stick\x20it\x20down,\x20you\x20can\x20create\x20beautiful\x20cozy\x20spreads.</div></div>',
    'fillStyle',
    'getImage',
    'linkPreview',
    'Start\x20Your\x20Hygge\x20Journey\x20Today',
    '5298oXnAWt',
    'beginPath',
    '<h2\x20class=\x22article-title\x22>',
  ];
  _0x130f = function () {
    return _0x263e60;
  };
  return _0x130f();
}
((function (_0x313cc4, _0x42a08d) {
  var _0x2bcb2c = _0x4c4f,
    _0x4baa63 = _0x313cc4();
  while (!![]) {
    try {
      var _0x10e0a1 =
        (-parseInt(_0x2bcb2c(0x225, 10)) / 0x1) * (parseInt(_0x2bcb2c(0x1ac, 10)) / 0x2) +
        (parseInt(_0x2bcb2c(0x1f9, 10)) / 0x3) * (parseInt(_0x2bcb2c(0x1a9, 10)) / 0x4) +
        (-parseInt(_0x2bcb2c(0x230, 10)) / 0x5) * (parseInt(_0x2bcb2c(0x1a2, 10)) / 0x6) +
        parseInt(_0x2bcb2c(0x212, 10)) / 0x7 +
        parseInt(_0x2bcb2c(0x1c5, 10)) / 0x8 +
        parseInt(_0x2bcb2c(0x23e, 10)) / 0x9 +
        (parseInt(_0x2bcb2c(0x1b5, 10)) / 0xa) * (-parseInt(_0x2bcb2c(0x1fb, 10)) / 0xb);
      if (_0x10e0a1 === _0x42a08d) break;
      else _0x4baa63['push'](_0x4baa63['shift']());
    } catch (_0x5f11a4) {
      _0x4baa63['push'](_0x4baa63['shift']());
    }
  }
})(_0x130f, 0x41b83),
  (function () {
    'use strict';
    var _0xdda186 = _0x4c4f;
    var _0x3d08d0 = {};
    ((_0x3d08d0['type'] = _0xdda186(0x1c9)),
      (_0x3d08d0['content'] =
        '<div\x20class=\x22featured-image-page\x22><img\x20src=\x22' +
        (window['hyggeFeaturedImage'] || '') +
        _0xdda186(0x1aa)));
    var _0x239ddb = {};
    ((_0x239ddb[_0xdda186(0x20e)] = _0xdda186(0x1b2)),
      (_0x239ddb['content'] =
        '<div\x20class=\x22centered-content\x22><div\x20class=\x22ornament\x22>&#10087;</div><div\x20class=\x22quote-text\x22>\x22Hygge\x20is\x20about\x20an\x20atmosphere\x20and\x20an\x20experience,\x20rather\x20than\x20about\x20things.\x20It\x20is\x20about\x20being\x20with\x20the\x20people\x20we\x20love.\x20A\x20feeling\x20of\x20home.\x20A\x20feeling\x20that\x20we\x20are\x20safe.\x22</div><div\x20class=\x22quote-attribution\x22>&#8212;\x20Meik\x20Wiking</div><div\x20class=\x22ornament\x22>&#10087;</div></div>'));
    var _0x421b4b = {};
    ((_0x421b4b[_0xdda186(0x20e)] = _0xdda186(0x1c1)),
      (_0x421b4b['content'] =
        '<div\x20class=\x22title-page\x22><div\x20class=\x22title-main\x22>Hygge\x20Crafting</div><div\x20class=\x22title-sub\x22>The\x20Danish\x20Art\x20of<br>Cozy\x20Winter\x20Journaling</div><div\x20class=\x22title-ornament\x22></div><div\x20class=\x22title-sub\x22>A\x20Guide\x20to\x20Creating\x20Soul-Nourishing<br>Journal\x20Spreads\x20by\x20Candlelight</div><div\x20class=\x22title-edition\x22>Winter\x20Edition\x20&bull;\x202025</div></div>'));
    var _0x148540 = {};
    ((_0x148540['type'] = 'article'),
      (_0x148540[_0xdda186(0x1c1)] = 'Introduction'),
      (_0x148540[_0xdda186(0x20f)] = _0xdda186(0x1e9)));
    var _0x2ad6e3 = {};
    ((_0x2ad6e3['type'] = 'article'),
      (_0x2ad6e3['title'] = _0xdda186(0x1f2)),
      (_0x2ad6e3['content'] =
        '<ul\x20class=\x22hygge-list\x22><li>Soft,\x20warm\x20lighting\x20(candles\x20or\x20string\x20lights)</li><li>Comfortable\x20seating\x20with\x20blankets\x20and\x20cushions</li><li>A\x20warm\x20beverage\x20(tea,\x20hot\x20chocolate,\x20coffee)</li><li>Cozy\x20textures\x20(fuzzy\x20socks,\x20soft\x20sweaters)</li><li>Pleasant\x20winter\x20scents\x20(vanilla,\x20cinnamon,\x20pine)</li><li>No\x20pressure\x20&#8211;\x20creating\x20for\x20pure\x20enjoyment</li><li>Complete\x20presence\x20(phone\x20on\x20silent)</li></ul>'));
    var _0x765b7e = {};
    ((_0x765b7e[_0xdda186(0x20e)] = _0xdda186(0x1ae)),
      (_0x765b7e[_0xdda186(0x1c1)] = 'Pinterest\x27s\x202026\x20Trend\x20Predictions'),
      (_0x765b7e['content'] = _0xdda186(0x1c7)));
    var _0x593d40 = {};
    ((_0x593d40['type'] = _0xdda186(0x1ae)),
      (_0x593d40['title'] = _0xdda186(0x204)),
      (_0x593d40[_0xdda186(0x20f)] =
        '<div\x20class=\x22trend-entry\x22><span\x20class=\x22trend-number\x22>2.</span><span\x20class=\x22trend-title\x22>Circus-Inspired\x20Maximalism</span><div\x20class=\x22article-body\x22><p>Bold\x20stripes,\x20playful\x20primary\x20colors,\x20and\x20whimsical\x20carnival\x20energy\x20bring\x20joy\x20to\x20journal\x20pages.\x20Think\x20vintage\x20circus\x20posters,\x20bold\x20typography,\x20and\x20unexpected\x20color\x20pops\x20that\x20make\x20crafting\x20feel\x20like\x20play.</p></div></div><div\x20class=\x22trend-entry\x22><span\x20class=\x22trend-number\x22>3.</span><span\x20class=\x22trend-title\x22>Neo\x20Deco</span><div\x20class=\x22article-body\x22><p>Art\x20Deco\x20evolves\x20with\x20<a\x20href=\x22https://coracreacrafts.com/products/celtic-knots-washi-tape?ref=blog-hygge\x22\x20class=\x22vintage-link\x22>geometric\x20patterns</a>,\x20chevrons,\x20fan\x20motifs,\x20and\x20metallic\x20accents\x20in\x20gold\x20and\x20brass.\x20This\x20trend\x20brings\x20sophisticated\x20structure\x20to\x20cozy\x20spreads.</p></div></div>'));
    var _0x6938c8 = {};
    ((_0x6938c8['type'] = _0xdda186(0x1ae)),
      (_0x6938c8['title'] = 'More\x20Trends'),
      (_0x6938c8[_0xdda186(0x20f)] =
        '<div\x20class=\x22trend-entry\x22><span\x20class=\x22trend-number\x22>4.</span><span\x20class=\x22trend-title\x22>Alien\x20Core\x20/\x20Extra\x20Celestial</span><div\x20class=\x22article-body\x22><p><a\x20href=\x22https://coracreacrafts.com/products/elven-pastes?ref=blog-hygge\x22\x20class=\x22vintage-link\x22>Holographic\x20papers</a>,\x20opalescent\x20stickers,\x20and\x20cosmic\x20themes\x20create\x20otherworldly\x20beauty.\x20Imagine\x20holographic\x20elements\x20dancing\x20in\x20candlelight\x20&#8211;\x20pure\x20hygge\x20magic.</p></div></div><div\x20class=\x22trend-entry\x22><span\x20class=\x22trend-number\x22>5.</span><span\x20class=\x22trend-title\x22>Gimme\x20Gummy</span><div\x20class=\x22article-body\x22><p><a\x20href=\x22https://coracreacrafts.com/products/haunted-transparent-tapes?ref=blog-hygge\x22\x20class=\x22vintage-link\x22>Translucent\x20papers</a>,\x20nostalgic\x20candy\x20colors,\x20and\x20layered\x20vellum\x20create\x20playful,\x20childlike\x20joy.\x20Stack\x20translucent\x20papers\x20for\x20subtle\x20depth\x20and\x20color-mixing\x20effects.</p></div></div>'));
    var _0x27bc48 = {};
    ((_0x27bc48['type'] = _0xdda186(0x1ae)),
      (_0x27bc48['title'] = 'Final\x20Trend\x20&\x20Your\x20First\x20Spread'),
      (_0x27bc48['content'] = _0xdda186(0x239)));
    var _0x26a55e = {};
    ((_0x26a55e['type'] = _0xdda186(0x1ae)),
      (_0x26a55e['title'] = _0xdda186(0x20c)),
      (_0x26a55e[_0xdda186(0x20f)] =
        '<ul\x20class=\x22supplies-list\x22><li>Navy\x20or\x20charcoal\x20base\x20papers</li><li>White\x20or\x20cream\x20accent\x20papers</li><li><a\x20href=\x22https://coracreacrafts.com/products/elven-pastes?ref=blog-hygge\x22\x20class=\x22vintage-link\x22>Holographic\x20star\x20stickers</a></li><li>Lace\x20doily\x20die-cuts</li><li>Silver\x20metallic\x20washi\x20tape</li><li><a\x20href=\x22https://coracreacrafts.com/products/enchanted-forest-foil-washi?ref=blog-hygge\x22\x20class=\x22vintage-link\x22>Botanical\x20ephemera</a>\x20(winter\x20branches,\x20pine)</li><li><a\x20href=\x22https://coracreacrafts.com/products/mystic-gel-pens?ref=blog-hygge\x22\x20class=\x22vintage-link\x22>White\x20gel\x20pen</a></li></ul>'));
    var _0x512ee1 = {};
    ((_0x512ee1[_0xdda186(0x20e)] = _0xdda186(0x1ae)),
      (_0x512ee1['title'] = _0xdda186(0x1da)),
      (_0x512ee1['content'] =
        '<ol\x20class=\x22steps-list\x22><li><strong>Set\x20atmosphere:</strong>\x20Light\x203-4\x20candles,\x20make\x20warm\x20tea,\x20wrap\x20in\x20blanket</li><li><strong>Create\x20dark\x20base:</strong>\x20Use\x20navy/charcoal\x20paper\x20representing\x20the\x20longest\x20night</li><li><strong>Add\x20horizon:</strong>\x20Silver\x20washi\x20tape\x201/3\x20up\x20from\x20bottom</li><li><strong>Focal\x20point:</strong>\x20Lace\x20doily\x20backed\x20with\x20holographic\x20paper\x20on\x20horizon\x20line</li><li><strong>Add\x20cosmos:</strong>\x20White\x20gel\x20pen\x20constellations\x20connecting\x20holographic\x20stars</li><li><strong>Ground\x20with\x20botanicals:</strong>\x20Layer\x20winter\x20botanical\x20ephemera\x20below\x20horizon</li><li><strong>Journal\x20reflections:</strong>\x20Write\x20solstice\x20intentions\x20in\x20silver\x20or\x20cream\x20ink</li><li><strong>Final\x20touches:</strong>\x20Small\x20holographic\x20accents\x20catching\x20candlelight</li></ol>'));
    var _0xdc67db = {};
    ((_0xdc67db['type'] = 'article'),
      (_0xdc67db['title'] = _0xdda186(0x1be)),
      (_0xdc67db[_0xdda186(0x20f)] =
        '<h3\x20class=\x22subsection-heading\x22>Budget-Friendly\x20Starter\x20Kit\x20($40)</h3><ul\x20class=\x22hygge-list\x22><li>1\x20pack\x20<a\x20href=\x22https://coracreacrafts.com/collections/ephemera?ref=blog-hygge\x22\x20class=\x22vintage-link\x22>vintage\x20ephemera</a>\x20(mixed)</li><li>2\x20rolls\x20<a\x20href=\x22https://coracreacrafts.com/products/garden-pond-washi-tape?ref=blog-hygge\x22\x20class=\x22vintage-link\x22>warm-toned\x20washi\x20tape</a></li><li>Basic\x20kraft\x20and\x20cream\x20papers</li><li>Glue\x20stick\x20and\x20scissors</li><li>1\x20botanical\x20stamp\x20+\x20<a\x20href=\x22https://coracreacrafts.com/products/aging-inkpads?ref=blog-hygge\x22\x20class=\x22vintage-link\x22>ink\x20pad</a></li></ul><h3\x20class=\x22subsection-heading\x22>Complete\x20Kit\x20($100)</h3><ul\x20class=\x22hygge-list\x22><li>3\x20packs\x20<a\x20href=\x22https://coracreacrafts.com/collections/ephemera?ref=blog-hygge\x22\x20class=\x22vintage-link\x22>curated\x20ephemera</a></li><li>6\x20rolls\x20premium\x20washi\x20tape</li><li>Quality\x20cutting\x20tools</li><li>3-4\x20stamps\x20+\x202\x20<a\x20href=\x22https://coracreacrafts.com/products/aging-inkpads?ref=blog-hygge\x22\x20class=\x22vintage-link\x22>ink\x20pads</a></li><li><a\x20href=\x22https://coracreacrafts.com/products/mystic-gel-pens?ref=blog-hygge\x22\x20class=\x22vintage-link\x22>Metallic\x20gel\x20pens</a></li></ul>'));
    var _0x300bc3 = {};
    ((_0x300bc3[_0xdda186(0x20e)] = _0xdda186(0x1ae)),
      (_0x300bc3['title'] = _0xdda186(0x1f4)),
      (_0x300bc3[_0xdda186(0x20f)] =
        '<div\x20class=\x22article-body\x22><p>Join\x20our\x20community\x20challenge\x20starting\x20January\x201st,\x202026:</p></div><div\x20class=\x22challenge-week\x22><h4\x20class=\x22week-heading\x22>Week\x201:\x20Hygge\x20Basics</h4><div\x20class=\x22article-body\x22><p>Days\x201-7:\x20Create\x20your\x20cozy\x20space,\x20simple\x20spreads,\x20candlelight\x20sessions,\x20texture\x20exploration</p></div></div><div\x20class=\x22challenge-week\x22><h4\x20class=\x22week-heading\x22>Week\x202:\x20Exploring\x202026\x20Trends</h4><div\x20class=\x22article-body\x22><p>Days\x208-14:\x20Lace\x20Revival,\x20Neo\x20Deco\x20geometry,\x20Alien\x20Core\x20cosmic\x20theme,\x20trend\x20mashup</p></div></div><div\x20class=\x22challenge-week\x22><h4\x20class=\x22week-heading\x22>Week\x203-4:\x20Personal\x20Style\x20&amp;\x20Sharing</h4><div\x20class=\x22article-body\x22><p>Days\x2015-30:\x20Discover\x20your\x20style,\x20gratitude,\x20intentions,\x20community\x20connection</p></div></div><div\x20class=\x22article-body\x22><p>Share\x20your\x20journey:\x20<strong>#HyggeChallenge2025</strong></p></div>'));
    var _0x4a7de5 = {};
    ((_0x4a7de5[_0xdda186(0x20e)] = 'article'),
      (_0x4a7de5['title'] = _0xdda186(0x1a6)),
      (_0x4a7de5[_0xdda186(0x20f)] =
        '<div\x20class=\x22article-body\x22><p>Research\x20shows\x20that\x20creating\x20in\x20cozy,\x20comfortable\x20environments:</p></div><div\x20class=\x22science-fact\x22><div\x20class=\x22fact-icon\x22>&#10023;</div><div\x20class=\x22fact-content\x22><strong>Reduces\x20cortisol\x20by\x20up\x20to\x2030%</strong>\x20&#8211;\x20Soft\x20lighting\x20and\x20warmth\x20signal\x20safety\x20to\x20your\x20nervous\x20system</div></div><div\x20class=\x22science-fact\x22><div\x20class=\x22fact-icon\x22>&#10023;</div><div\x20class=\x22fact-content\x22><strong>Increases\x20dopamine</strong>\x20&#8211;\x20Tactile\x20crafting\x20+\x20cozy\x20atmosphere\x20=\x20multiple\x20pleasure\x20sources</div></div><div\x20class=\x22science-fact\x22><div\x20class=\x22fact-icon\x22>&#10023;</div><div\x20class=\x22fact-content\x22><strong>Enhances\x20creativity</strong>\x20&#8211;\x20Your\x20brain\x20shifts\x20from\x20survival\x20mode\x20to\x20creative\x20mode\x20when\x20comfortable</div></div><div\x20class=\x22science-fact\x22><div\x20class=\x22fact-icon\x22>&#10023;</div><div\x20class=\x22fact-content\x22><strong>Improves\x20flow\x20states</strong>\x20&#8211;\x2075%\x20of\x20crafters\x20enter\x20flow\x20within\x2010\x20minutes;\x20hygge\x20elements\x20increase\x20this</div></div>'));
    var _0x1acd1c = {};
    ((_0x1acd1c[_0xdda186(0x20e)] = _0xdda186(0x1ae)),
      (_0x1acd1c['title'] = _0xdda186(0x21e)),
      (_0x1acd1c[_0xdda186(0x20f)] =
        '<h3\x20class=\x22subsection-heading\x22>Weekly\x20Hygge\x20Dates</h3><div\x20class=\x22article-body\x22><p>Pick\x20one\x20evening\x20per\x20week\x20as\x20your\x20\x22hygge\x20crafting\x20night.\x22\x20Same\x20day,\x20same\x20cozy\x20ritual,\x201-2\x20hours\x20of\x20pure\x20presence.\x20Even\x20one\x20spread\x20per\x20week\x20creates\x2052\x20beautiful\x20pages\x20per\x20year.</p></div><h3\x20class=\x22subsection-heading\x22>Seasonal\x20Themes</h3><ul\x20class=\x22hygge-list\x22><li><strong>January:</strong>\x20Intentions\x20and\x20fresh\x20starts</li><li><strong>February:</strong>\x20Love\x20and\x20connection</li><li><strong>March:</strong>\x20Transition\x20and\x20hope</li><li><strong>December:</strong>\x20Coziness\x20and\x20celebration</li></ul><h3\x20class=\x22subsection-heading\x22>Community\x20Connection</h3><div\x20class=\x22article-body\x22><p>Hygge\x20is\x20enriched\x20by\x20community.\x20Host\x20monthly\x20hygge\x20craft\x20nights\x20with\x202-4\x20friends,\x20or\x20join\x20our\x20<a\x20href=\x22https://discord.gg/coracreacrafts\x22\x20class=\x22vintage-link\x22>Discord\x20community</a>.</p></div>'));
    var _0x38ab17 = {};
    ((_0x38ab17['type'] = _0xdda186(0x1ae)),
      (_0x38ab17[_0xdda186(0x1c1)] = _0xdda186(0x1db)),
      (_0x38ab17[_0xdda186(0x20f)] = _0xdda186(0x19d)));
    var _0x4c689c = {};
    ((_0x4c689c[_0xdda186(0x20e)] = 'article'),
      (_0x4c689c[_0xdda186(0x1c1)] = _0xdda186(0x1a1)),
      (_0x4c689c['content'] =
        '<div\x20class=\x22article-body\x22><p>You\x20don\x27t\x20need\x20perfect\x20supplies\x20or\x20the\x20\x22right\x20time.\x22\x20Start\x20now:</p></div><ol\x20class=\x22steps-list\x22><li>Light\x20a\x20candle\x20or\x20warm\x20lamp</li><li>Make\x20yourself\x20a\x20warm\x20beverage</li><li>Gather\x20whatever\x20craft\x20supplies\x20you\x20have</li><li>Wrap\x20yourself\x20in\x20something\x20cozy</li><li>Spend\x2015\x20minutes\x20creating\x20something\x20warm\x20and\x20comforting</li></ol><div\x20class=\x22article-body\x22><p><em>Hygge\x20crafting\x20starts\x20the\x20moment\x20you\x20choose\x20presence\x20and\x20coziness\x20over\x20productivity\x20and\x20perfection.</em></p></div><h3\x20class=\x22subsection-heading\x22>Explore\x20More\x20Hygge\x20Inspiration:</h3><ul\x20class=\x22hygge-list\x22><li><a\x20href=\x22https://coracreacrafts.com/blogs/inspiration-nook/self-care-through-vintage-crafting\x22\x20class=\x22vintage-link\x22>Self-Care\x20Through\x20Crafting</a></li><li><a\x20href=\x22https://coracreacrafts.com/blogs/inspiration-nook/how-to-create-themed-junk-journal-spread\x22\x20class=\x22vintage-link\x22>How\x20to\x20Create\x20Themed\x20Journal\x20Spreads</a></li><li><a\x20href=\x22https://coracreacrafts.com/blogs/inspiration-nook/gen-z-loves-vintage-aesthetic-crafting\x22\x20class=\x22vintage-link\x22>Why\x20Gen\x20Z\x20Loves\x20Vintage\x20Crafting</a></li></ul>'));
    var _0x5ece4e = {};
    ((_0x5ece4e[_0xdda186(0x20e)] = _0xdda186(0x1ea)), (_0x5ece4e['content'] = _0xdda186(0x224)));
    var _0x531c07 = [
        _0x3d08d0,
        _0x239ddb,
        _0x421b4b,
        _0x148540,
        _0x2ad6e3,
        _0x765b7e,
        _0x593d40,
        _0x6938c8,
        _0x27bc48,
        _0x26a55e,
        _0x512ee1,
        _0xdc67db,
        _0x300bc3,
        _0x4a7de5,
        _0x1acd1c,
        _0x38ab17,
        _0x4c689c,
        _0x5ece4e,
      ],
      _0x2b8bec = ![],
      _0x39ba50 = ![],
      _0x51eade = null,
      _0x3fe69f = null,
      _0x8cbb37 = null,
      _0x9cc4a9 = null,
      _0x3a6ec0 = null,
      _0x449696 = ![],
      _0x24f510 = {};
    ((_0x24f510[_0xdda186(0x21b)] =
      'https://cdn.shopify.com/s/files/1/0709/1594/8764/files/9281copy.jpg?v=1747063851'),
      (_0x24f510[_0xdda186(0x1c1)] = _0xdda186(0x1ec)));
    var _0x313f8a = {};
    ((_0x313f8a[_0xdda186(0x21b)] = _0xdda186(0x1b1)),
      (_0x313f8a[_0xdda186(0x1c1)] = 'Celtic\x20Knots\x20Washi\x20Tape'));
    var _0x37041f = {};
    ((_0x37041f['image'] =
      'https://cdn.shopify.com/s/files/1/0709/1594/8764/files/202507_ElvenPastes6.jpg?v=1751382303'),
      (_0x37041f[_0xdda186(0x1c1)] = _0xdda186(0x1dc)));
    var _0x567cef = {};
    ((_0x567cef[_0xdda186(0x21b)] = _0xdda186(0x19c)),
      (_0x567cef[_0xdda186(0x1c1)] = 'Haunted\x20Transparent\x20Tapes'));
    var _0x30268b = {};
    ((_0x30268b[_0xdda186(0x21b)] =
      'https://cdn.shopify.com/s/files/1/0709/1594/8764/files/202303_FoilEnchantedWashiTape1.jpg?v=1726023764'),
      (_0x30268b['title'] = 'Enchanted\x20Forest\x20Foil\x20Washi'));
    var _0xcca78 = {};
    ((_0xcca78[_0xdda186(0x21b)] = _0xdda186(0x1e3)),
      (_0xcca78[_0xdda186(0x1c1)] = _0xdda186(0x1d5)));
    var _0x56ef30 = {};
    ((_0x56ef30[_0xdda186(0x21b)] = _0xdda186(0x1fd)), (_0x56ef30['title'] = _0xdda186(0x1f1)));
    var _0x24960b = {};
    ((_0x24960b['image'] =
      'https://cdn.shopify.com/s/files/1/0709/1594/8764/files/202303_FoilEnchantedWashiTape1.jpg?v=1726023764'),
      (_0x24960b['title'] = _0xdda186(0x1e7)));
    var _0x3ae041 = {};
    ((_0x3ae041['coquette-washi-tape-set'] = _0x24f510),
      (_0x3ae041['celtic-knots-washi-tape'] = _0x313f8a),
      (_0x3ae041['elven-pastes'] = _0x37041f),
      (_0x3ae041[_0xdda186(0x226)] = _0x567cef),
      (_0x3ae041['enchanted-forest-foil-washi'] = _0x30268b),
      (_0x3ae041['mystic-gel-pens'] = _0xcca78),
      (_0x3ae041['aging-inkpads'] = _0x56ef30),
      (_0x3ae041['garden-pond-washi-tape'] = _0x24960b));
    var _0x5e9642 = _0x3ae041,
      _0x450fbd = [
        'https://cdn.shopify.com/s/files/1/0709/1594/8764/files/9281copy.jpg?v=1747063851',
        _0xdda186(0x1b1),
        'https://cdn.shopify.com/s/files/1/0709/1594/8764/files/202507_ElvenPastes6.jpg?v=1751382303',
        'https://cdn.shopify.com/s/files/1/0709/1594/8764/files/202303_FoilEnchantedWashiTape1.jpg?v=1726023764',
        _0xdda186(0x1fd),
        _0xdda186(0x1e3),
      ];
    function _0x658d33() {
      var _0x7a536a = _0xdda186;
      return _0x450fbd[Math['floor'](Math['random']() * _0x450fbd[_0x7a536a(0x22b)])];
    }
    var _0x4e79e5 = {};
    ((_0x4e79e5['getImage'] = _0x658d33), (_0x4e79e5['title'] = _0xdda186(0x1bd)));
    var _0x17b0a9 = {};
    ((_0x17b0a9[_0xdda186(0x21b)] = _0xdda186(0x1ee)),
      (_0x17b0a9[_0xdda186(0x1c1)] = _0xdda186(0x1e5)));
    var _0x43fac5 = {};
    ((_0x43fac5[_0xdda186(0x206)] = _0x4e79e5), (_0x43fac5['all'] = _0x17b0a9));
    var _0x10d170 = _0x43fac5,
      _0x172398 = {};
    ((_0x172398[_0xdda186(0x21b)] =
      'https://cdn.shopify.com/s/files/1/0709/1594/8764/files/self-care-featured.png'),
      (_0x172398[_0xdda186(0x1c1)] = 'Self-Care\x20Through\x20Vintage\x20Crafting'));
    var _0x51627c = {};
    ((_0x51627c['image'] =
      'https://cdn.shopify.com/s/files/1/0709/1594/8764/files/hygge-winter-journaling-cozy-setup.jpg'),
      (_0x51627c['title'] = 'How\x20to\x20Create\x20Themed\x20Journal\x20Spreads'));
    var _0xd97bd2 = {};
    ((_0xd97bd2['image'] = _0xdda186(0x1af)),
      (_0xd97bd2['title'] = 'Why\x20Gen\x20Z\x20Loves\x20Vintage\x20Crafting'));
    var _0x442a39 = {};
    ((_0x442a39['self-care-through-vintage-crafting'] = _0x172398),
      (_0x442a39['how-to-create-themed-junk-journal-spread'] = _0x51627c),
      (_0x442a39['gen-z-loves-vintage-aesthetic-crafting'] = _0xd97bd2));
    var _0x2add2f = _0x442a39,
      _0x13dac9 = null;
    function _0x42ae57() {
      var _0x10883a = _0xdda186;
      if (!window['hyggePageFlipSound']) return;
      (!_0x51eade &&
        ((_0x51eade = new Audio(window['hyggePageFlipSound'])), (_0x51eade['volume'] = 0.6)),
        (_0x51eade[_0x10883a(0x203)] = 0x0),
        _0x51eade['play']()['catch'](function () {}));
    }
    function _0x41ee1a() {
      var _0x39c2da = _0xdda186;
      if (!window['hyggeBookOpenSound']) return;
      (!_0x3fe69f &&
        ((_0x3fe69f = new Audio(window[_0x39c2da(0x23b)])), (_0x3fe69f['volume'] = 0.7)),
        (_0x3fe69f[_0x39c2da(0x203)] = 0x0),
        _0x3fe69f['play']()['catch'](function () {}));
    }
    function _0x45ebcd() {
      var _0x36c197 = _0xdda186;
      if (!window['hyggeBookCloseSound']) return;
      (!_0x8cbb37 &&
        ((_0x8cbb37 = new Audio(window['hyggeBookCloseSound'])),
        (_0x8cbb37[_0x36c197(0x234)] = 0.7)),
        (_0x8cbb37['currentTime'] = 0x0),
        _0x8cbb37[_0x36c197(0x19b)]()['catch'](function () {}));
    }
    function _0x2eddbc() {
      var _0x5361e3 = _0xdda186;
      (window[_0x5361e3(0x1f5)] &&
        ((_0x9cc4a9 = new Audio(window[_0x5361e3(0x1f5)])),
        (_0x9cc4a9['volume'] = 0.2),
        (_0x9cc4a9[_0x5361e3(0x1e6)] = !![])),
        window[_0x5361e3(0x233)] &&
          ((_0x3a6ec0 = new Audio(window[_0x5361e3(0x233)])),
          (_0x3a6ec0[_0x5361e3(0x234)] = 0.35),
          (_0x3a6ec0[_0x5361e3(0x1e6)] = !![])));
    }
    function _0x37ffcb() {
      var _0xe5164b = _0xdda186;
      !_0x9cc4a9 && !_0x3a6ec0 && _0x2eddbc();
      if (!_0x9cc4a9 && !_0x3a6ec0) return;
      var _0x888da3 = document[_0xe5164b(0x235)]('musicToggle'),
        _0x44278b = _0x888da3 ? _0x888da3['querySelector'](_0xe5164b(0x1b6)) : null;
      if (_0x449696) {
        if (_0x9cc4a9) _0x9cc4a9[_0xe5164b(0x228)]();
        if (_0x3a6ec0) _0x3a6ec0['pause']();
        _0x449696 = ![];
        if (_0x888da3) _0x888da3[_0xe5164b(0x1ba)][_0xe5164b(0x1b0)]('playing');
        _0x44278b &&
          (_0x44278b['classList'][_0xe5164b(0x1b0)]('music-on'),
          _0x44278b['classList'][_0xe5164b(0x223)]('music-off'));
      } else {
        if (_0x9cc4a9) _0x9cc4a9['play']()['catch'](function () {});
        if (_0x3a6ec0) _0x3a6ec0[_0xe5164b(0x19b)]()['catch'](function () {});
        _0x449696 = !![];
        if (_0x888da3) _0x888da3['classList']['add'](_0xe5164b(0x208));
        _0x44278b &&
          (_0x44278b['classList']['remove']('music-off'),
          _0x44278b[_0xe5164b(0x1ba)]['add'](_0xe5164b(0x1ed)));
      }
    }
    function _0x4ee7c5(_0x36cb11) {
      var _0x43aa56 = _0x36cb11['match'](/\/products\/([^?\/]+)/);
      return _0x43aa56 ? _0x43aa56[0x1] : null;
    }
    function _0x2c989c(_0x143c73) {
      var _0x2df5f7 = _0xdda186,
        _0x25fac7 = _0x143c73[_0x2df5f7(0x1cf)](/\/collections\/([^?\/]+)/);
      return _0x25fac7 ? _0x25fac7[0x1] : null;
    }
    function _0xbbd4a5(_0x4e4425) {
      var _0xf856d1 = _0xdda186,
        _0x32dfdb = _0x4e4425[_0xf856d1(0x1cf)](/\/blogs\/[^\/]+\/([^?\/]+)/);
      return _0x32dfdb ? _0x32dfdb[0x1] : null;
    }
    function _0x1ffd13(_0x11ddfc, _0x374e95) {
      var _0x12205d = _0xdda186,
        _0xf0a441 = _0x11ddfc['getAttribute'](_0x12205d(0x221));
      if (!_0xf0a441) return;
      var _0x4c5662 = null,
        _0x15b4c9 = _0x4ee7c5(_0xf0a441);
      _0x15b4c9 && _0x5e9642[_0x15b4c9] && (_0x4c5662 = _0x5e9642[_0x15b4c9]);
      if (!_0x4c5662) {
        var _0x19684f = _0x2c989c(_0xf0a441);
        _0x19684f && _0x10d170[_0x19684f] && (_0x4c5662 = _0x10d170[_0x19684f]);
      }
      if (!_0x4c5662) {
        var _0xb35634 = _0xbbd4a5(_0xf0a441);
        _0xb35634 && _0x2add2f[_0xb35634] && (_0x4c5662 = _0x2add2f[_0xb35634]);
      }
      if (!_0x4c5662) return;
      var _0x17d791 = document['getElementById']('linkPreview'),
        _0x387b46 = document[_0x12205d(0x235)]('linkPreviewImage'),
        _0x462e7e = document['getElementById']('linkPreviewTitle');
      if (!_0x17d791 || !_0x387b46 || !_0x462e7e) return;
      var _0x286096 = _0x4c5662[_0x12205d(0x19f)] ? _0x4c5662['getImage']() : _0x4c5662['image'];
      ((_0x387b46[_0x12205d(0x1bc)] = _0x286096),
        (_0x387b46['alt'] = _0x4c5662['title']),
        (_0x462e7e[_0x12205d(0x1ef)] = _0x4c5662['title']),
        (_0x387b46[_0x12205d(0x20b)] = function () {
          var _0x10ebc = _0x12205d;
          window[_0x10ebc(0x1de)] &&
            _0x387b46['src'] !== window[_0x10ebc(0x1de)] &&
            (_0x387b46['src'] = window['hyggeFeaturedImage']);
        }));
      var _0x59abd8 = window['innerWidth'],
        _0x222480,
        _0x1a48da;
      if (_0x59abd8 >= 0x640)
        ((_0x222480 = Math['min'](0x21c, _0x59abd8 * 0.28)),
          (_0x1a48da = Math['min'](0x1a4, _0x59abd8 * 0.24)));
      else {
        if (_0x59abd8 >= 0x4b0)
          ((_0x222480 = Math[_0x12205d(0x1a8)](0x1e0, _0x59abd8 * 0.3)),
            (_0x1a48da = Math['min'](0x17c, _0x59abd8 * 0.26)));
        else
          _0x59abd8 >= 0x300
            ? ((_0x222480 = Math[_0x12205d(0x1a8)](0x1a4, _0x59abd8 * 0.35)),
              (_0x1a48da = Math['min'](0x154, _0x59abd8 * 0.28)))
            : ((_0x222480 = 0xb4), (_0x1a48da = 0xdc));
      }
      var _0x4999a5 = _0x11ddfc['getBoundingClientRect'](),
        _0x293892 = window['scrollX'] || window['pageXOffset'],
        _0x5c712d = window['scrollY'] || window['pageYOffset'],
        _0x5e5dcc =
          _0x4999a5[_0x12205d(0x1d9)] + _0x293892 + _0x4999a5['width'] / 0x2 - _0x222480 / 0x2,
        _0x59ae8d = _0x4999a5['top'] + _0x5c712d - _0x1a48da - 0xa;
      if (_0x5e5dcc < 0xa) _0x5e5dcc = 0xa;
      (_0x5e5dcc + _0x222480 > window[_0x12205d(0x232)] - 0xa &&
        (_0x5e5dcc = window[_0x12205d(0x232)] - _0x222480 - 0xa),
        _0x59ae8d < _0x5c712d + 0xa && (_0x59ae8d = _0x4999a5['bottom'] + _0x5c712d + 0xa),
        (_0x17d791['style'][_0x12205d(0x1d9)] = _0x5e5dcc + 'px'),
        (_0x17d791[_0x12205d(0x1e2)][_0x12205d(0x231)] = _0x59ae8d + 'px'),
        _0x17d791[_0x12205d(0x1ba)][_0x12205d(0x223)]('visible'));
    }
    function _0x21692b() {
      var _0x1bbd8e = _0xdda186,
        _0x42e0cc = document[_0x1bbd8e(0x235)](_0x1bbd8e(0x1a0));
      _0x42e0cc && _0x42e0cc[_0x1bbd8e(0x1ba)][_0x1bbd8e(0x1b0)]('visible');
    }
    function _0x47071b() {
      var _0x192586 = _0xdda186;
      ($(document)['on']('mouseenter', _0x192586(0x20d), function (_0x5ec49d) {
        _0x1ffd13(this, _0x5ec49d);
      }),
        $(document)['on']('mouseleave', _0x192586(0x20d), function () {
          _0x21692b();
        }));
      var _0x3a1f64 = document['getElementById']('musicToggle');
      (_0x3a1f64 && _0x3a1f64[_0x192586(0x242)]('click', _0x37ffcb), _0x38151f());
    }
    function _0x38151f() {
      var _0x500257 = _0xdda186;
      if (!window[_0x500257(0x1f5)] && !window['hyggeFireplaceSound']) return;
      _0x2eddbc();
      if (!_0x9cc4a9 && !_0x3a6ec0) return;
      var _0x1b0ab0 = document[_0x500257(0x235)]('musicToggle'),
        _0x2d6bca = _0x1b0ab0 ? _0x1b0ab0[_0x500257(0x1c6)]('.music-icon') : null,
        _0x3a93f9 = _0x9cc4a9 ? _0x9cc4a9['play']() : _0x3a6ec0 ? _0x3a6ec0['play']() : null;
      _0x3a93f9 !== undefined &&
        _0x3a93f9 !== null &&
        _0x3a93f9[_0x500257(0x1fc)](function () {
          var _0x33b2df = _0x500257;
          if (_0x3a6ec0 && _0x9cc4a9) _0x3a6ec0['play']()['catch'](function () {});
          _0x449696 = !![];
          if (_0x1b0ab0) _0x1b0ab0[_0x33b2df(0x1ba)]['add'](_0x33b2df(0x208));
          _0x2d6bca &&
            (_0x2d6bca[_0x33b2df(0x1ba)][_0x33b2df(0x1b0)]('music-off'),
            _0x2d6bca[_0x33b2df(0x1ba)]['add']('music-on'));
        })[_0x500257(0x200)](function () {
          var _0x41c293 = _0x500257;
          _0x449696 = ![];
          var _0x327e34 = {};
          ((_0x327e34[_0x41c293(0x1c4)] = !![]),
            document['addEventListener'](
              'click',
              function _0xa9447e() {
                var _0x5edfb3 = _0x41c293;
                if (!_0x449696) {
                  if (_0x9cc4a9) _0x9cc4a9[_0x5edfb3(0x19b)]()['catch'](function () {});
                  if (_0x3a6ec0) _0x3a6ec0[_0x5edfb3(0x19b)]()[_0x5edfb3(0x200)](function () {});
                  _0x449696 = !![];
                  if (_0x1b0ab0) _0x1b0ab0['classList']['add'](_0x5edfb3(0x208));
                  _0x2d6bca &&
                    (_0x2d6bca['classList']['remove'](_0x5edfb3(0x23c)),
                    _0x2d6bca['classList']['add'](_0x5edfb3(0x1ed)));
                }
                document['removeEventListener']('click', _0xa9447e);
              },
              _0x327e34
            ));
        });
    }
    function _0x511b8a(_0x4e29a5) {
      var _0x3c90a0 = Math['sin'](_0x4e29a5) * 0x2710;
      return _0x3c90a0 - Math['floor'](_0x3c90a0);
    }
    function _0x42ff34(_0x1d2187, _0x471ba1, _0x4004e9, _0x5705ef) {
      var _0x5d4dba = _0xdda186,
        _0x497cbf = _0x1d2187[_0x5d4dba(0x237)]('2d'),
        _0x44a16d = _0x1d2187[_0x5d4dba(0x1c8)],
        _0x539e13 = _0x1d2187[_0x5d4dba(0x214)];
      ((_0x497cbf['fillStyle'] =
        _0x5d4dba(0x1e1) + _0x471ba1 + ',' + _0x4004e9 + ',' + _0x5705ef + ')'),
        _0x497cbf[_0x5d4dba(0x22a)](0x0, 0x0, _0x44a16d, _0x539e13));
      var _0xb0ecc2 = _0x497cbf[_0x5d4dba(0x1b3)](0x0, 0x0, _0x44a16d, _0x539e13),
        _0x155044 = _0xb0ecc2[_0x5d4dba(0x238)];
      for (var _0x1455fb = 0x0; _0x1455fb < _0x539e13; _0x1455fb++) {
        for (var _0xe96a5d = 0x0; _0xe96a5d < _0x44a16d; _0xe96a5d++) {
          var _0x38bd92 = (_0x1455fb * _0x44a16d + _0xe96a5d) * 0x4,
            _0x6dfdb2 = 0x0;
          _0x6dfdb2 += (_0x511b8a(_0xe96a5d * 1.3 + _0x1455fb * 1.1 + 0x64) - 0.5) * 0xf;
          var _0x34bdc2 = Math['floor'](_0xe96a5d / 0x5),
            _0x4aa889 = Math['floor'](_0x1455fb / 0x5);
          _0x6dfdb2 += (_0x511b8a(_0x34bdc2 * 17.3 + _0x4aa889 * 13.7 + 0xc8) - 0.5) * 0xc;
          var _0x342b77 = Math[_0x5d4dba(0x1ca)](_0xe96a5d / 0x13),
            _0x1faf04 = Math['floor'](_0x1455fb / 0x17);
          _0x6dfdb2 += (_0x511b8a(_0x342b77 * 29.1 + _0x1faf04 * 31.7 + 0x12c) - 0.5) * 0xa;
          var _0x14dbda = _0x511b8a(_0xe96a5d * 0.9 + _0x1455fb * 0.8 + 0x3e8);
          if (_0x14dbda > 0.94)
            _0x6dfdb2 -= 0x12 + _0x511b8a(_0xe96a5d + _0x1455fb * _0x44a16d + 0x7d0) * 0xc;
          else {
            if (_0x14dbda > 0.88)
              _0x6dfdb2 -= 0x6 + _0x511b8a(_0xe96a5d + _0x1455fb * _0x44a16d + 0xbb8) * 0x6;
          }
          ((_0x155044[_0x38bd92] = Math[_0x5d4dba(0x205)](
            0x0,
            Math[_0x5d4dba(0x1a8)](0xff, _0x471ba1 + _0x6dfdb2)
          )),
            (_0x155044[_0x38bd92 + 0x1] = Math['max'](
              0x0,
              Math['min'](0xff, _0x4004e9 + _0x6dfdb2 * 0.85)
            )),
            (_0x155044[_0x38bd92 + 0x2] = Math[_0x5d4dba(0x205)](
              0x0,
              Math['min'](0xff, _0x5705ef + _0x6dfdb2 * 0.7)
            )));
        }
      }
      _0x497cbf['putImageData'](_0xb0ecc2, 0x0, 0x0);
      var _0x48662e = _0x497cbf[_0x5d4dba(0x1f3)](
        _0x44a16d / 0x2,
        _0x539e13 / 0x2,
        _0x539e13 * 0.15,
        _0x44a16d / 0x2,
        _0x539e13 / 0x2,
        _0x539e13 * 0.85
      );
      (_0x48662e['addColorStop'](0x0, _0x5d4dba(0x227)),
        _0x48662e[_0x5d4dba(0x1e8)](0.5, 'rgba(0,0,0,0.08)'),
        _0x48662e[_0x5d4dba(0x1e8)](0x1, _0x5d4dba(0x236)),
        (_0x497cbf[_0x5d4dba(0x19e)] = _0x48662e),
        _0x497cbf['fillRect'](0x0, 0x0, _0x44a16d, _0x539e13));
      var _0x38f4de = _0x497cbf['createLinearGradient'](
        0x0,
        0x0,
        _0x44a16d * 0.25,
        _0x539e13 * 0.25
      );
      (_0x38f4de[_0x5d4dba(0x1e8)](0x0, 'rgba(255,255,255,0.05)'),
        _0x38f4de[_0x5d4dba(0x1e8)](0x1, _0x5d4dba(0x227)),
        (_0x497cbf['fillStyle'] = _0x38f4de),
        _0x497cbf['fillRect'](0x0, 0x0, _0x44a16d, _0x539e13));
    }
    function _0x157eba(_0x19516f) {
      var _0x854773 = _0xdda186,
        _0x5868e4 = _0x19516f[_0x854773(0x237)]('2d'),
        _0x1da4c4 = _0x19516f['width'],
        _0x2efc65 = _0x19516f['height'];
      for (var _0x26a0c3 = 0x0; _0x26a0c3 < _0x2efc65; _0x26a0c3++) {
        for (var _0x284c97 = 0x0; _0x284c97 < _0x1da4c4; _0x284c97++) {
          var _0x2da5bb = _0x284c97 / _0x1da4c4,
            _0x124b84 = Math[_0x854773(0x1ce)](_0x2da5bb * Math['PI']),
            _0x2cdc14 = 0xa5 + _0x124b84 * 0x28,
            _0x7de56d = 0x8c + _0x124b84 * 0x23,
            _0x2126ae = 0x69 + _0x124b84 * 0x19,
            _0x522b95 = (_0x511b8a(_0x284c97 * 1.2 + _0x26a0c3 * 0.9 + 0xbb8) - 0.5) * 0x12,
            _0x40cd6e = Math[_0x854773(0x1ca)](_0x284c97 / 0x4),
            _0x2ec651 = Math[_0x854773(0x1ca)](_0x26a0c3 / 0xb);
          ((_0x522b95 += (_0x511b8a(_0x40cd6e * 7.3 + _0x2ec651 * 11.7 + 0xfa0) - 0.5) * 0xa),
            (_0x5868e4['fillStyle'] =
              _0x854773(0x1e1) +
              Math['max'](0x0, Math['min'](0xff, _0x2cdc14 + _0x522b95)) +
              ',' +
              Math['max'](0x0, Math['min'](0xff, _0x7de56d + _0x522b95)) +
              ',' +
              Math['max'](0x0, Math[_0x854773(0x1a8)](0xff, _0x2126ae + _0x522b95)) +
              ')'),
            _0x5868e4[_0x854773(0x22a)](_0x284c97, _0x26a0c3, 0x1, 0x1));
        }
      }
      var _0x20de0f = _0x5868e4[_0x854773(0x22f)](_0x1da4c4 * 0.45, 0x0, _0x1da4c4, 0x0);
      (_0x20de0f[_0x854773(0x1e8)](0x0, 'rgba(0,0,0,0)'),
        _0x20de0f['addColorStop'](0.5, 'rgba(0,0,0,0.18)'),
        _0x20de0f[_0x854773(0x1e8)](0x1, _0x854773(0x207)),
        (_0x5868e4['fillStyle'] = _0x20de0f),
        _0x5868e4[_0x854773(0x22a)](0x0, 0x0, _0x1da4c4, _0x2efc65));
      var _0x5b8c2d = _0x5868e4['createLinearGradient'](0x0, 0x0, _0x1da4c4 * 0.55, 0x0);
      (_0x5b8c2d['addColorStop'](0x0, 'rgba(255,255,255,0.06)'),
        _0x5b8c2d['addColorStop'](0.35, _0x854773(0x217)),
        _0x5b8c2d['addColorStop'](0x1, _0x854773(0x227)),
        (_0x5868e4['fillStyle'] = _0x5b8c2d),
        _0x5868e4['fillRect'](0x0, 0x0, _0x1da4c4, _0x2efc65));
    }
    function _0x35ff90(_0x320bb3, _0x5f002b) {
      var _0x5777d5 = _0xdda186,
        _0x8d5607 = _0x320bb3['getContext']('2d'),
        _0xd84c52 = _0x320bb3['width'],
        _0x34a15c = _0x320bb3[_0x5777d5(0x214)],
        _0x9653ae = 0xd0 + (_0x5f002b % 0x5) * 0x2,
        _0x55066e = 0xbc + (_0x5f002b % 0x4) * 0x2,
        _0x1e4892 = 0x9e + (_0x5f002b % 0x3) * 0x2;
      ((_0x8d5607['fillStyle'] =
        _0x5777d5(0x1e1) + _0x9653ae + ',' + _0x55066e + ',' + _0x1e4892 + ')'),
        _0x8d5607[_0x5777d5(0x22a)](0x0, 0x0, _0xd84c52, _0x34a15c));
      var _0x4475db = _0x8d5607['getImageData'](0x0, 0x0, _0xd84c52, _0x34a15c),
        _0x3bd516 = _0x4475db[_0x5777d5(0x238)],
        _0x4324d0 = _0x5f002b * 0x1eef;
      for (var _0x56df17 = 0x0; _0x56df17 < _0x34a15c; _0x56df17++) {
        for (var _0x554ba5 = 0x0; _0x554ba5 < _0xd84c52; _0x554ba5++) {
          var _0x59ed01 = (_0x56df17 * _0xd84c52 + _0x554ba5) * 0x4,
            _0x386fda = 0x0;
          _0x386fda += (_0x511b8a(_0x554ba5 * 1.1 + _0x56df17 * 1.3 + _0x4324d0) - 0.5) * 0xa;
          var _0x356b6a = Math['floor'](_0x554ba5 / 0x7),
            _0x521422 = Math[_0x5777d5(0x1ca)](_0x56df17 / 0x7);
          _0x386fda +=
            (_0x511b8a(_0x356b6a * 13.7 + _0x521422 * 17.3 + _0x4324d0 + 0x64) - 0.5) * 0x8;
          var _0x257254 = Math[_0x5777d5(0x1ca)](_0x554ba5 / 0x17),
            _0x1c4ff0 = Math['floor'](_0x56df17 / 0x1d);
          _0x386fda +=
            (_0x511b8a(_0x257254 * 31.1 + _0x1c4ff0 * 37.7 + _0x4324d0 + 0xc8) - 0.5) * 0x6;
          var _0x339c7e = (Math[_0x5777d5(0x205)](0x0, 0x28 - _0x554ba5) / 0x28) * 0xf;
          _0x386fda -= _0x339c7e;
          var _0x141e39 = _0x554ba5,
            _0x42c682 = _0xd84c52 - _0x554ba5,
            _0x4dc7e1 = _0x56df17,
            _0x1a8a19 = _0x34a15c - _0x56df17,
            _0x10b792 = Math[_0x5777d5(0x1a8)](_0x141e39, _0x42c682, _0x4dc7e1, _0x1a8a19),
            _0x3b226b = Math['max'](0x0, (0x2d - _0x10b792) / 0x2d) * 0xa,
            _0x36bda8 = [
              Math[_0x5777d5(0x1ad)](_0x554ba5 * _0x554ba5 + _0x56df17 * _0x56df17),
              Math[_0x5777d5(0x1ad)](
                (_0xd84c52 - _0x554ba5) * (_0xd84c52 - _0x554ba5) + _0x56df17 * _0x56df17
              ),
              Math['sqrt'](
                _0x554ba5 * _0x554ba5 + (_0x34a15c - _0x56df17) * (_0x34a15c - _0x56df17)
              ),
              Math['sqrt'](
                (_0xd84c52 - _0x554ba5) * (_0xd84c52 - _0x554ba5) +
                  (_0x34a15c - _0x56df17) * (_0x34a15c - _0x56df17)
              ),
            ],
            _0x151f3f = Math[_0x5777d5(0x1a8)]['apply'](null, _0x36bda8),
            _0x325edc = Math[_0x5777d5(0x205)](0x0, (0x82 - _0x151f3f) / 0x82) * 0xc,
            _0x464408 = _0x9653ae + _0x386fda - _0x325edc * 0.2 - _0x3b226b * 0.3,
            _0x31063b = _0x55066e + _0x386fda - _0x325edc * 0.35 - _0x3b226b * 0.35,
            _0x320fc1 = _0x1e4892 + _0x386fda - _0x325edc * 0.5 - _0x3b226b * 0.4;
          ((_0x3bd516[_0x59ed01] = Math[_0x5777d5(0x205)](
            0x0,
            Math[_0x5777d5(0x1a8)](0xff, _0x464408)
          )),
            (_0x3bd516[_0x59ed01 + 0x1] = Math[_0x5777d5(0x205)](
              0x0,
              Math['min'](0xff, _0x31063b)
            )),
            (_0x3bd516[_0x59ed01 + 0x2] = Math[_0x5777d5(0x205)](
              0x0,
              Math[_0x5777d5(0x1a8)](0xff, _0x320fc1)
            )));
        }
      }
      (_0x8d5607['putImageData'](_0x4475db, 0x0, 0x0),
        (_0x8d5607['globalCompositeOperation'] = _0x5777d5(0x1c0)));
      var _0x44e51e = 0x8 + Math[_0x5777d5(0x1ca)](_0x511b8a(_0x4324d0 + 0x1f4) * 0xc);
      for (var _0x2c188e = 0x0; _0x2c188e < _0x44e51e; _0x2c188e++) {
        var _0x355569 = _0x511b8a(_0x4324d0 + _0x2c188e * 0x7) * _0xd84c52,
          _0x40e7f8 = _0x511b8a(_0x4324d0 + _0x2c188e * 0x7 + 0x1) * _0x34a15c,
          _0x5a703b = 0x4 + _0x511b8a(_0x4324d0 + _0x2c188e * 0x7 + 0x2) * 0xc,
          _0x13869c = 0.015 + _0x511b8a(_0x4324d0 + _0x2c188e * 0x7 + 0x3) * 0.025,
          _0x18dab5 = 0.5 + _0x511b8a(_0x4324d0 + _0x2c188e * 0x7 + 0x4) * 0x1,
          _0x2c601f = _0x511b8a(_0x4324d0 + _0x2c188e * 0x7 + 0x5) * Math['PI'],
          _0x910edf = _0x8d5607['createRadialGradient'](0x0, 0x0, 0x0, 0x0, 0x0, _0x5a703b);
        (_0x910edf['addColorStop'](0x0, 'rgba(120,\x2090,\x2060,\x20' + _0x13869c + ')'),
          _0x910edf['addColorStop'](0.6, _0x5777d5(0x218) + _0x13869c * 0.4 + ')'),
          _0x910edf['addColorStop'](0x1, _0x5777d5(0x1b9)),
          (_0x8d5607['fillStyle'] = _0x910edf),
          _0x8d5607[_0x5777d5(0x1fa)](),
          _0x8d5607[_0x5777d5(0x1e0)](_0x355569, _0x40e7f8),
          _0x8d5607['rotate'](_0x2c601f),
          _0x8d5607[_0x5777d5(0x1f8)](0x1, _0x18dab5),
          _0x8d5607[_0x5777d5(0x1a3)](),
          _0x8d5607[_0x5777d5(0x22c)](0x0, 0x0, _0x5a703b, 0x0, Math['PI'] * 0x2),
          _0x8d5607[_0x5777d5(0x1ff)](),
          _0x8d5607[_0x5777d5(0x241)]());
      }
      var _0x17b7cf = 0xf + Math['floor'](_0x511b8a(_0x4324d0 + 0x258) * 0x14);
      for (var _0x5a06df = 0x0; _0x5a06df < _0x17b7cf; _0x5a06df++) {
        var _0x53975e = _0x511b8a(_0x4324d0 + _0x5a06df + 0x2bc) * _0xd84c52,
          _0x3bb62d = _0x511b8a(_0x4324d0 + _0x5a06df + 0x320) * _0x34a15c,
          _0x102cec = 0.5 + _0x511b8a(_0x4324d0 + _0x5a06df + 0x384) * 1.2;
        ((_0x8d5607['fillStyle'] =
          _0x5777d5(0x23d) + (0.04 + _0x511b8a(_0x4324d0 + _0x5a06df + 0x3e8) * 0.05) + ')'),
          _0x8d5607[_0x5777d5(0x1a3)](),
          _0x8d5607[_0x5777d5(0x22c)](_0x53975e, _0x3bb62d, _0x102cec, 0x0, Math['PI'] * 0x2),
          _0x8d5607[_0x5777d5(0x1ff)]());
      }
      _0x8d5607[_0x5777d5(0x1ab)] = 'source-over';
    }
    function _0xdaef86(_0x5634c1, _0x22d8e5) {
      var _0x49d0eb = _0xdda186;
      return (
        '<div\x20class=\x22page-inner\x22><canvas\x20class=\x22paper-canvas\x22\x20width=\x22960\x22\x20height=\x221200\x22\x20data-page=\x22' +
        _0x22d8e5 +
        '\x22></canvas><div\x20class=\x22fold-shadow\x22></div><div\x20class=\x22page-content\x22>' +
        _0x5634c1 +
        _0x49d0eb(0x1cc) +
        (_0x22d8e5 > 0x0
          ? '<div\x20class=\x22page-number\x22>' + _0x22d8e5 + _0x49d0eb(0x1cc)
          : '') +
        '</div>'
      );
    }
    function _0x4644c0() {
      var _0x5cabdc = _0xdda186,
        _0x248cec = 0x23,
        _0x45e474 = 0x262,
        _0x54586e = 'M\x200\x20' + (0x5 + Math[_0x5cabdc(0x1a5)]() * 0x8);
      for (var _0x16fbcf = 0x0; _0x16fbcf <= _0x45e474; _0x16fbcf += 0xf) {
        var _0x39ad93 =
          Math[_0x5cabdc(0x1ce)](_0x16fbcf * 0.05) * 0x2 +
          (_0x511b8a(_0x16fbcf + 0x3e8) - 0.5) * 0x3;
        _0x54586e += _0x5cabdc(0x21d) + Math[_0x5cabdc(0x205)](0x0, _0x39ad93) + '\x20' + _0x16fbcf;
      }
      var _0x370eef = _0x45e474 - 0x3 - Math['random']() * 0x6;
      ((_0x54586e +=
        _0x5cabdc(0x21d) + _0x248cec * 0.3 + '\x20' + (_0x370eef + Math[_0x5cabdc(0x1a5)]() * 0x4)),
        (_0x54586e +=
          _0x5cabdc(0x21d) +
          _0x248cec * 0.6 +
          '\x20' +
          (_0x370eef + Math[_0x5cabdc(0x1a5)]() * 0x3)),
        (_0x54586e +=
          '\x20L\x20' + _0x248cec + '\x20' + (_0x370eef + Math[_0x5cabdc(0x1a5)]() * 0x5)));
      for (var _0x44a7b7 = _0x45e474; _0x44a7b7 >= 0x0; _0x44a7b7 -= 0x14) {
        var _0x300fa1 = _0x248cec + (_0x511b8a(_0x44a7b7 + 0x7d0) - 0.5) * 0x2;
        _0x54586e += _0x5cabdc(0x21d) + _0x300fa1 + '\x20' + _0x44a7b7;
      }
      var _0x1d34bb = 0x4 + Math[_0x5cabdc(0x1a5)]() * 0x7;
      ((_0x54586e +=
        _0x5cabdc(0x21d) + _0x248cec * 0.7 + '\x20' + (_0x1d34bb + Math[_0x5cabdc(0x1a5)]() * 0x4)),
        (_0x54586e +=
          '\x20L\x20' + _0x248cec * 0.4 + '\x20' + (_0x1d34bb + Math['random']() * 0x3)),
        (_0x54586e += '\x20Z'));
      var _0x10affa = document[_0x5cabdc(0x235)]('spineClipPath');
      _0x10affa && _0x10affa['setAttribute']('d', _0x54586e);
    }
    function _0x515ccf() {
      var _0x52cb9c = _0xdda186,
        _0x2d1806 = $('#flipbook');
      if (!_0x2d1806[_0x52cb9c(0x238)](_0x52cb9c(0x1b4))) return;
      var _0x9d4766 = _0x2d1806['turn'](_0x52cb9c(0x213)),
        _0x5b8348 = _0x2d1806[_0x52cb9c(0x1b4)](_0x52cb9c(0x1fe));
      if (_0x39ba50) {
        ($('#prevBtn')['prop'](_0x52cb9c(0x1df), !![])['css']('opacity', _0x52cb9c(0x1c3)),
          $('#nextBtn')
            [_0x52cb9c(0x219)]('disabled', !![])
            [_0x52cb9c(0x1d4)]('opacity', _0x52cb9c(0x1c3)));
        return;
      }
      (_0x2b8bec && _0x9d4766 === 0x1
        ? $(_0x52cb9c(0x1f6))
            ['text']('Close')
            [_0x52cb9c(0x219)]('disabled', ![])
            [_0x52cb9c(0x1d4)]('opacity', '1')
        : ($(_0x52cb9c(0x1f6))
            [_0x52cb9c(0x211)](_0x52cb9c(0x1d2))
            [_0x52cb9c(0x219)](_0x52cb9c(0x1df), !_0x2b8bec || _0x9d4766 <= 0x1),
          $('#prevBtn')['css']('opacity', !_0x2b8bec || _0x9d4766 <= 0x1 ? _0x52cb9c(0x1c3) : '1')),
        $('#nextBtn')['prop']('disabled', _0x2b8bec && _0x9d4766 >= _0x5b8348),
        $('#nextBtn')[_0x52cb9c(0x1d4)](
          _0x52cb9c(0x1d7),
          _0x2b8bec && _0x9d4766 >= _0x5b8348 ? '0.35' : '1'
        ));
    }
    function _0x4212c1() {
      var _0x2e46bb = _0xdda186;
      if (_0x2b8bec || _0x39ba50) return;
      ((_0x39ba50 = !![]), _0x515ccf(), _0x41ee1a());
      var _0x49cb2a = $('#flipbook'),
        _0x31d247 = $(_0x2e46bb(0x222));
      (_0x31d247['addClass'](_0x2e46bb(0x1c2)),
        $(_0x2e46bb(0x210))['addClass'](_0x2e46bb(0x240)),
        $('#spineShadow')['addClass']('visible'),
        $('#coverUnderneath')['addClass']('visible'),
        (_0x2b8bec = !![]),
        setTimeout(function () {
          var _0x170663 = _0x2e46bb;
          (_0x49cb2a[_0x170663(0x1d4)]('visibility', 'visible'),
            _0x49cb2a['turn'](_0x170663(0x213), 0x1));
        }, 0x190),
        setTimeout(function () {
          ((_0x39ba50 = ![]), _0x515ccf());
        }, 0x384));
    }
    function _0xbd216e() {
      var _0x2e9cb5 = _0xdda186;
      if (!_0x2b8bec || _0x39ba50) return;
      ((_0x39ba50 = !![]), _0x515ccf(), _0x45ebcd());
      var _0x304d0e = $('#flipbook'),
        _0x5a6817 = $(_0x2e9cb5(0x222)),
        _0xaae207 = $('#rolledSpine'),
        _0x35589a = $('#spineShadow'),
        _0xc9c96e = $('#coverUnderneath'),
        _0x331cba = $(_0x2e9cb5(0x1d8));
      ((_0x2b8bec = ![]),
        _0xc9c96e[_0x2e9cb5(0x1bf)](_0x2e9cb5(0x240))[_0x2e9cb5(0x21a)](_0x2e9cb5(0x220)),
        _0xaae207['removeClass']('visible')[_0x2e9cb5(0x21a)]('hiding'),
        _0x35589a[_0x2e9cb5(0x1bf)](_0x2e9cb5(0x240))['addClass']('hiding'),
        _0x331cba['addClass'](_0x2e9cb5(0x229)),
        _0x5a6817['addClass']('closing'),
        setTimeout(function () {
          var _0x1399b3 = _0x2e9cb5;
          _0x304d0e['css']('visibility', _0x1399b3(0x23f));
        }, 0x320),
        setTimeout(function () {
          var _0x180adb = _0x2e9cb5;
          (_0x5a6817['removeClass'](_0x180adb(0x21c)),
            _0xaae207[_0x180adb(0x1bf)]('hiding\x20visible'),
            _0x35589a['removeClass']('hiding\x20visible'),
            _0xc9c96e['removeClass']('hiding\x20visible'),
            _0x331cba[_0x180adb(0x1bf)](_0x180adb(0x229)),
            _0x304d0e[_0x180adb(0x238)](_0x180adb(0x1b4)) &&
              _0x304d0e['turn'](_0x180adb(0x213), 0x1),
            (_0x39ba50 = ![]),
            _0x515ccf());
        }, 0x6a4));
    }
    function _0x20e95c() {
      var _0x1c1ec5 = _0xdda186,
        _0x3bec97 = document[_0x1c1ec5(0x235)](_0x1c1ec5(0x202)),
        _0x518a2d = document[_0x1c1ec5(0x235)]('coverUnderneathCanvas'),
        _0x3bae99 = document['getElementById']('spineCanvas');
      if (_0x3bec97) _0x42ff34(_0x3bec97, 0x46, 0x2d, 0x19);
      if (_0x518a2d) _0x42ff34(_0x518a2d, 0x3c, 0x26, 0x16);
      if (_0x3bae99) _0x157eba(_0x3bae99);
      _0x4644c0();
      var _0x3abe11 = $(_0x1c1ec5(0x1dd));
      for (var _0x2294bc = 0x0; _0x2294bc < _0x531c07['length']; _0x2294bc++) {
        var _0x30d78d = _0x531c07[_0x2294bc],
          _0x321e2a = '';
        if (
          _0x30d78d['type'] === _0x1c1ec5(0x1c9) ||
          _0x30d78d['type'] === _0x1c1ec5(0x1b2) ||
          _0x30d78d[_0x1c1ec5(0x20e)] === 'title' ||
          _0x30d78d['type'] === _0x1c1ec5(0x1ea)
        )
          _0x321e2a = _0x30d78d['content'];
        else
          _0x30d78d[_0x1c1ec5(0x20e)] === 'article' &&
            (_0x321e2a =
              _0x1c1ec5(0x1a4) + _0x30d78d[_0x1c1ec5(0x1c1)] + '</h2>' + _0x30d78d['content']);
        var _0x51ba45 = _0x2294bc + 0x1;
        _0x3abe11['append'](
          '<div\x20class=\x22page\x22>' + _0xdaef86(_0x321e2a, _0x51ba45) + _0x1c1ec5(0x1cc)
        );
      }
      (_0x3abe11[_0x1c1ec5(0x1b4)]({
        width: 0x1e0,
        height: 0x258,
        autoCenter: !![],
        display: _0x1c1ec5(0x1cb),
        acceleration: !![],
        gradients: !![],
        elevation: 0xc8,
        duration: 0x9c4,
        corners: _0x1c1ec5(0x1b7),
        when: {
          turning: function () {
            (_0x42ae57(),
              requestAnimationFrame(function () {
                var _0x3bde6b = _0x4c4f,
                  _0x3e0990 = document[_0x3bde6b(0x1d6)]('.paper-canvas');
                for (var _0x21be97 = 0x0; _0x21be97 < _0x3e0990['length']; _0x21be97++) {
                  var _0x324335 = _0x3e0990[_0x21be97];
                  if (!_0x324335['dataset'][_0x3bde6b(0x215)]) {
                    var _0x1b78dc =
                      parseInt(_0x324335['dataset'][_0x3bde6b(0x213, 10)]) ||
                      Math['floor'](Math[_0x3bde6b(0x1a5)]() * 0x64);
                    (_0x35ff90(_0x324335, _0x1b78dc),
                      (_0x324335[_0x3bde6b(0x21f)][_0x3bde6b(0x215)] = 'true'));
                  }
                }
              }));
          },
          turned: function () {
            _0x515ccf();
          },
        },
      }),
        _0x3abe11['on'](_0x1c1ec5(0x20a), _0x1c1ec5(0x216), function (_0x2fc072) {
          var _0x23bcbf = _0x1c1ec5;
          if ($(_0x2fc072['target'])[_0x23bcbf(0x1d3)]('a')[_0x23bcbf(0x22b)]) return;
          if (_0x39ba50) return;
          (_0x2fc072['preventDefault'](), _0x2fc072[_0x23bcbf(0x1d0)]());
          var _0x11f762 =
              _0x2fc072[_0x23bcbf(0x1cd)] ||
              _0x2fc072[_0x23bcbf(0x1bb)] - $(this)[_0x23bcbf(0x1a7)]()[_0x23bcbf(0x1d9)],
            _0x5e8e65 = $(this)['width']();
          if (_0x11f762 < _0x5e8e65 * 0.33) {
            var _0x57501e = _0x3abe11['turn'](_0x23bcbf(0x213));
            _0x57501e === 0x1 ? _0xbd216e() : _0x3abe11[_0x23bcbf(0x1b4)](_0x23bcbf(0x1d1));
          } else _0x3abe11[_0x23bcbf(0x1b4)](_0x23bcbf(0x209));
        }),
        setTimeout(function () {
          var _0x5a54da = _0x1c1ec5,
            _0x31d950 = document['querySelectorAll']('.paper-canvas');
          for (var _0xc8a44e = 0x0; _0xc8a44e < _0x31d950['length']; _0xc8a44e++) {
            var _0xc3e13c = _0x31d950[_0xc8a44e],
              _0x47f96e =
                parseInt(_0xc3e13c[_0x5a54da(0x21f, 10)]['page']) ||
                Math['floor'](Math['random']() * 0x64);
            (_0x35ff90(_0xc3e13c, _0x47f96e), (_0xc3e13c['dataset'][_0x5a54da(0x215)] = 'true'));
          }
        }, 0x64),
        _0x3abe11['css']('visibility', _0x1c1ec5(0x23f)),
        $(document)['on'](_0x1c1ec5(0x20a), '.toc-item', function () {
          var _0x1feab6 = _0x1c1ec5;
          if (_0x39ba50) return;
          var _0x4168d4 = $(this)['data'](_0x1feab6(0x213));
          _0x4168d4 && _0x3abe11['turn'](_0x1feab6(0x213), _0x4168d4);
        }),
        $('#leatherCover')['on']('click', function () {
          if (_0x39ba50) return;
          _0x4212c1();
        }),
        $(_0x1c1ec5(0x1f6))['on'](_0x1c1ec5(0x20a), function () {
          var _0xbd1f59 = _0x1c1ec5;
          if (_0x39ba50) return;
          if (_0x2b8bec) {
            var _0x2b817f = _0x3abe11[_0xbd1f59(0x1b4)]('page');
            _0x2b817f === 0x1 ? _0xbd216e() : _0x3abe11['turn'](_0xbd1f59(0x1d1));
          }
        }),
        $('#nextBtn')['on']('click', function () {
          var _0x40cfd6 = _0x1c1ec5;
          if (_0x39ba50) return;
          !_0x2b8bec ? _0x4212c1() : _0x3abe11[_0x40cfd6(0x1b4)](_0x40cfd6(0x209));
        }),
        $(document)['on'](_0x1c1ec5(0x1eb), function (_0x128d3b) {
          var _0xd9239 = _0x1c1ec5;
          if (_0x39ba50) return;
          if (!_0x2b8bec) return;
          if (_0x128d3b[_0xd9239(0x22d)] === _0xd9239(0x201) || _0x128d3b['key'] === 'PageDown')
            (_0x128d3b[_0xd9239(0x1f0)](), _0x3abe11[_0xd9239(0x1b4)](_0xd9239(0x209)));
          else {
            if (
              _0x128d3b[_0xd9239(0x22d)] === 'ArrowLeft' ||
              _0x128d3b['key'] === _0xd9239(0x1f7)
            ) {
              _0x128d3b['preventDefault']();
              var _0x160e8e = _0x3abe11[_0xd9239(0x1b4)](_0xd9239(0x213));
              _0x160e8e === 0x1 ? _0xbd216e() : _0x3abe11[_0xd9239(0x1b4)]('previous');
            }
          }
        }),
        _0x515ccf(),
        _0x47071b(),
        setTimeout(function () {
          var _0x8e0b2 = _0x1c1ec5;
          document[_0x8e0b2(0x23a)]['classList']['add']('page-loaded');
        }, 0x96));
    }
    function _0x1308c5() {
      var _0x4c412d = _0xdda186;
      if (
        typeof jQuery !== _0x4c412d(0x1e4) &&
        typeof jQuery['fn'][_0x4c412d(0x1b4)] !== 'undefined'
      )
        $(document)[_0x4c412d(0x1b8)](_0x20e95c);
      else {
        var _0x59ae2b = setInterval(function () {
          var _0x473bf1 = _0x4c412d;
          typeof jQuery !== _0x473bf1(0x1e4) &&
            typeof jQuery['fn'][_0x473bf1(0x1b4)] !== _0x473bf1(0x1e4) &&
            (clearInterval(_0x59ae2b), $(document)['ready'](_0x20e95c));
        }, 0x64);
        setTimeout(function () {
          clearInterval(_0x59ae2b);
        }, 0x2710);
      }
    }
    (_0x1308c5(),
      (window[_0xdda186(0x22e)] = {
        open: _0x4212c1,
        close: _0xbd216e,
        nextPage: function () {
          var _0x226be9 = _0xdda186;
          if (!_0x39ba50) $('#flipbook')[_0x226be9(0x1b4)]('next');
        },
        previousPage: function () {
          var _0x39f7ca = _0xdda186;
          if (!_0x39ba50) $('#flipbook')['turn'](_0x39f7ca(0x1d1));
        },
        goToPage: function (_0x28b992) {
          var _0x26e3d6 = _0xdda186;
          if (!_0x39ba50) $('#flipbook')[_0x26e3d6(0x1b4)]('page', _0x28b992);
        },
        isAnimating: function () {
          return _0x39ba50;
        },
        isOpen: function () {
          return _0x2b8bec;
        },
      }));
  })());
